import { render, staticRenderFns } from "./ComponentAddSortable.vue?vue&type=template&id=bb951d6a"
import script from "./ComponentAddSortable.vue?vue&type=script&lang=js"
export * from "./ComponentAddSortable.vue?vue&type=script&lang=js"
import style0 from "./ComponentAddSortable.vue?vue&type=style&index=0&id=bb951d6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports